import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-star-rating",
  templateUrl: "./star-rating.component.html",
  styleUrls: ["./star-rating.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class StarRatingComponent implements OnInit {
  @Input() score;
  @Input() maxScore = 5;
  @Input() forDisplay = false;
  @Output() rateChanged = new EventEmitter();

  range = [];
  marked = -1;

  constructor() {}

  ngOnInit() {
    for (var i = 0; i < this.maxScore; i++) {
      this.range.push(i);
    }
  }

  public mark = (index) => {
    this.marked = this.marked == index ? index - 1 : index;
    this.score = this.marked + 1;
    this.rateChanged.next(this.score);
  };

  public isMarked = (index) => {
    if (!this.forDisplay) {
      if (index <= this.marked) {
        return "fa-solid fa-star";
      } else {
        return "fa-regular fa-star";
      }
    } else {
      if (this.score >= index + 1) {
        return "fa-solid fa-star";
      } else if (this.score > index && this.score < index + 1) {
        return "fa-solid fa-star-half-stroke";
      } else {
        return "fa-regular fa-star";
      }
    }
  };
}
